import { createMemoryHistory } from "history";

export default createMemoryHistory({
  initialEntries: ["/signin", "/offices", "/office"],
  initialIndex: 0
});
